import axios from "axios";
import { getWsToken } from "@services/account/auth";

export async function getPumpingStatus() {
    const res = await getWsToken();
    const config = {
        headers: {
            Token: res.data.ws_token,
        },
    };

    return axios.get(
        (document.querySelector("body").getAttribute("socketapi") ||
            process.env.VUE_APP_SOCKET_API) +
                "/systemStatus/pumpingStatus",
        config
    );
}
